import React, { useState } from 'react';
import {  Button, InlineLoading } from 'carbon-components-react';
import { useNavigate } from "react-router-dom";
import useMsalApi from '../../components/use-msal-api';
import { useDispatch, useSelector } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import { updateEnollmentsType } from '../../redux/actions/enrollments-actions';
import ClaycoForm from '../../components/form_elements/clayco-form';
import LifeEventForm from './life-event-form';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import * as Yup from 'yup';
import { RequiredDate, RequiredLookup, RequiredString } from '../../components/form_elements/form-validators';
import { format, parseISO } from 'date-fns';
import SubmitButton from '../../components/form_elements/submit-button';
import { setAdminSessions } from '../../redux/actions/admin-actions';


const SelectedAction = ()  => {
    const navigate = useNavigate();
    const [callApi] = useMsalApi();
    const enrollments = useSelector(s => s.enrollments);
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);
    const admin = useSelector(s => s.admin);

    const validationSchema = Yup.object().shape({
        effectiveDate:  RequiredDate("Required"),
        lifeEventId: RequiredString("Required"),
        lifeEventDescription: RequiredString("Required")
    });

    const onSubmit = async(formData) => {
        const frm = validationSchema.cast(formData);
        console.log(frm);
        setSubmitting(true);

        const params = {
            enrollmentTypeId: EnrollmentType.LifeEvent,
            effectiveDate: frm.effectiveDate,
            lifeEventId: frm.lifeEventId,
            lifeEventDescription: frm.lifeEventDescription ,   
            currentStep: enrollments.currentStep 
        }

        if(enrollments.effectiveDate && format(params.effectiveDate, 'MM/dd/yyyy') === format(parseISO(enrollments.effectiveDate), 'MM/dd/yyyy')){
            const results = await callApi(`Enrollments/${enrollments.id}/type`, "PATCH", params);
            if(!results.error){
                dispatch(updateEnollmentsType(results));
            }
        } else {
            const results = await callApi(`Enrollments/${enrollments.id}/effectiveDate/${enrollments.employee.id}`, "PATCH", params);
            if(!results.error){
                dispatch(updateEnrollments(results));
            }
        }

        navigate("/Employee");
        setSubmitting(false);
    }

    const onError = (errors) => {
        console.log(errors);
    }

    console.log(admin);

    const startOver = async () => {
        setSubmitting(true);
        var path = `Enrollments/${enrollments.id}/${enrollments.employee.id}`;
        if(admin.isAdmin){
            path = `Enrollments/${enrollments.id}`
        }
        var results = await callApi(path, "DELETE");
        if(!results.error){
            if(admin.isAdmin){
                dispatch(updateEnrollments([]));
                dispatch(setAdminSessions(admin.sessions.filter(s => s.id !== enrollments.id)))
                navigate('/Admin');
            } else {
                dispatch(updateEnrollments(results));
            }
        }

        setSubmitting(false);
    }

    return ( 
        <>
        <div className="font-bold text-3xl mb-4">Employee Benefits</div>
        <div className="mb-8">
          <div className="text-xl mb-4">Please continue your enrollment process.</div>
        </div>
        {enrollments.enrollmentTypeId === EnrollmentType.LifeEvent ?
        <ClaycoForm schema={validationSchema} onSubmit={onSubmit} onError={onError}>
            <LifeEventForm />
            <>
            <SubmitButton submitting={submitting}>
                Continue Benefits Enrollment
            </SubmitButton>
            {!submitting ? 
                <Button kind="ghost" type="button" onClick={startOver}>Start Over</Button> 
                : <></>
            }
            
        </>
        </ClaycoForm>
        : <>
            {!submitting ? <>
                <>
                <Button onClick={() => {navigate("/Employee");}}>Continue Benefits Enrollment</Button>
                <Button kind="ghost" type="button" onClick={startOver}>Start Over</Button> 
                </>
                </> :
                <InlineLoading description="Resetting..." /> 
            }        
          </>
        }
        <p className='my-8'>
        <strong>Questions?</strong>  Contact Beth Mellenthin  at 314-592-2206 or Sara Benignus at 314-614-5880 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a> . 
        </p>

        </>
    );
}
 
export default SelectedAction;